import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule} from '@angular/material/button';

import { ListSearchSelectDialog } from './list-search-select-dialog.component';

@NgModule({
  declarations: [
    ListSearchSelectDialog
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule
  ],
  exports: [
    ListSearchSelectDialog
  ]
})
export class ListSearchSelectDialogModule { }
